import { RouteComponentProps } from 'react-router';
import React, { useEffect, useState } from 'react';
import { reservationApi } from '../../../api/reservation/reservation.client';
import { LogModel } from '../../../api/reservation/reservation.types';
import XMLModal from '../../../components/modals/XMLModal';
import { useTranslation } from 'react-i18next';
import ListViewTable from '../../../components/tables/ListViewTable';
import { LoaderBar } from '../../../components/forms/LoaderBar';

type LogType = 'broker' | 'payment' | 'backend_integration';

enum ReservationLogType {
  BACKEND_INTEGRATION = 'BACKEND_INTEGRATION',
  PAYMENT = 'PAYMENT',
  BROKER = 'BROKER',

}

interface ReservationLogsTableViewLocationProps {
  number: string;
  type: string;
}

const ReservationLogsTableView: React.FC<RouteComponentProps<ReservationLogsTableViewLocationProps>> =
  (props) => {

    const [ logs, setLogs ] = useState<LogModel[]>([]);
    const [ logsOpen, setLogsOpen ] = useState<boolean>(false);
    const [ modalData, setModalData ] = useState<string>('');
    const [ pageTitle, setPageTitle ] = useState('');
    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    const { t } = useTranslation();

    useEffect(() => {
      const number = props.match.params.number;
      const type = props.match.params.type as LogType;
      switch (type) {
        case 'backend_integration':
          reservationApi.Reservations.getReservationLogs(number, ReservationLogType.BACKEND_INTEGRATION)
            .then((response) => {
              setLogs(response.data.logs ? response.data.logs : []);
              setPageTitle(t('page_title.reservation_logs_table_view.backend_integration'));
              setIsLoading(false);
            });
          break;
        case 'payment':
          reservationApi.Reservations.getReservationLogs(number, ReservationLogType.PAYMENT)
            .then((response) => {
              setLogs(response.data.logs ? response.data.logs : []);
              setPageTitle(t('page_title.reservation_logs_table_view.payment'));
              setIsLoading(false);
            });
          break;
        case 'broker':
          reservationApi.Reservations.getReservationLogs(number, ReservationLogType.BROKER)
            .then((response) => {
              setLogs(response.data.logs ? response.data.logs : []);
              setPageTitle(t('page_title.reservation_logs_table_view.broker'));
              setIsLoading(false);
            });
          break;
      }
    }, [ props.match.params, t ]);

    function handleOpenLogModal(data: any, type: 'REQUEST' | 'RESPONSE') {
      if (type === 'REQUEST') {
        setModalData(data.request);
      } else {
        setModalData(data.response);
      }
      setLogsOpen(true);
    }

    const requestTimeCell = (elmProps: any) =>
      <div
        onClick={() => handleOpenLogModal(elmProps.row.original, 'REQUEST')}
      >{elmProps.row.original.requestTimestamp}
        <button type="button" className="pl-1 btn btn-text-only">
          {t('b.reservation_logs_table_view.open_logs')}
        </button>
      </div>;

    const responseTimeCell = (elmProps: any) =>
      <div
        onClick={() => handleOpenLogModal(elmProps.row.original, 'RESPONSE')}
      >{elmProps.row.original.responseTimestamp}
        <button type="button" className="pl-1 btn btn-text-only">
          {t('b.reservation_logs_table_view.open_logs')}
        </button>
      </div>;

    function defineColumns() {
      return [
        {
          header: t('ct.reservation_logs_table_view.request_type'),
          accessorKey: 'requestType',
          minWidth: 250,
          width: 250
        },
        {
          header: t('ct.reservation_logs_table_view.request_timestamp'),
          accessorKey: 'requestTimestamp',
          cell: requestTimeCell,
          minWidth: 300,
          width: 300
        },
        {
          header: t('ct.reservation_logs_table_view.response_timestamp'),
          accessorKey: 'responseTimestamp',
          cell: responseTimeCell,
          minWidth: 300,
          width: 300
        }
      ];
    }


    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">{t('page_title.reservation_logs_table_view.reservation_no', {
              reservationNumber: props.match.params.number
            })}</h1>
            <h1 className="mb-0">{pageTitle}</h1>
          </div>
        </div>
        {isLoading && <LoaderBar/>}
        <ListViewTable
          data={logs}
          columns={defineColumns()}
        />
        <XMLModal toggle={() => setLogsOpen(false)}
                  isOpen={logsOpen}
                  xmlData={modalData}
                  onClose={() => setLogsOpen(false)}
        />
      </div>
    );
  };

export default ReservationLogsTableView;
